import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    avatar: {
      height: '60px',
      width: '60px',
    },
    badge: {
      '& .MuiBadge-badge': {
        right: theme.spacing(),
        bottom: theme.spacing(),
      },
    },
    container: {
      width: '100%',
    },
    root: {
      display: 'flex',
      paddingTop: theme.spacing(0.5),
      textAlign: 'center',
      color: theme.palette.text.primary,
      textTransform: 'initial',
      textDecoration: 'none',
    },
    typography: {
      fontSize: theme.typography.caption.fontSize,
      lineHeight: theme.typography.h2.lineHeight,
      marginTop: theme.spacing(0.5),
    },
  };
};
